import repository from "../Repository";

export default {
  async list(screenId) {
    return await repository.post("car/equipment-list", {
      headers: {
        s: screenId
      }
    });
  }
};
